
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FieldItemProps } from ".";
import { loading, fieldRemove, endLoading } from "store/form";

interface ApiFieldSortInputProps {
    ids: number[]
}

type ApiFieldSortOutputProps = OutputBaseProps<{ item: FieldItemProps; }>

export const apiFieldSort = async (data: ApiFieldSortInputProps, formId: number) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiFieldSortOutputProps>(`/api/form/${formId}/field/sort`, { ids: data.ids }))
        .data;
    if (res.status) {
        store.dispatch(endLoading());
    }
    store.dispatch(endLoading());
    return res;
};